import React from "react";
import { NavLink } from "react-router-dom";

export default function Cart({ cartList }) {
  return (
    <div className="cart">
      <NavLink to="/index/my-cart">
        <span className="numberCircle">{cartList.carts.length || 0}</span>
        <button className="view-cart" type="submit" name="submit" value>
          <i className="fa fa-cart-arrow-down" aria-hidden="true" />
        </button>
      </NavLink>
    </div>
  );
}
